// src/PrivateRoute.tsx
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const isAuthenticated = (): boolean => {
  // Check if the token exists in localStorage
  const token = localStorage.getItem('token');
  return !!token; // Returns true if the token exists, otherwise false
};

const PrivateRoute: React.FC = () => {
  return isAuthenticated() ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoute;
